import { useAuth } from '@clerk/clerk-react';

const API_BASE = process.env.REACT_APP_API_URL || '';

export function useHistoryApi() {
  const { getToken } = useAuth();
  const withAuth = async (fetcher) => {
    const token = await getToken();
    return fetcher(token);
  };

  const saveHistory = async ({ chatId, destination, response }) =>
    withAuth((token) =>
      fetch(`${API_BASE}/api/history/savehistory`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ chatId, destination, response }),
        cache: 'no-store',
      }).then(r => {
        if (!r.ok) throw new Error(`Save history failed (${r.status})`);
        return r.json();
      })
    );

  const fetchHistoryList = () =>
    withAuth((token) =>
      fetch(`${API_BASE}/api/history/listhistory`, {
        headers: { 'Authorization': `Bearer ${token}` },
        cache: 'no-store',
      })
      .then(r => {
        if (!r.ok) throw new Error(`Failed to fetch history (${r.status})`);
        return r.json();
      })
    );

  const fetchHistoryItem = (chatId) =>
    withAuth((token) =>
      fetch(`${API_BASE}/api/history/${chatId}`, {
        headers: { 'Authorization': `Bearer ${token}` },
        cache: 'no-store',
      }).then(r => {
        if (!r.ok) throw new Error(`Failed to fetch history item (${r.status})`);
        return r.json();
      })
    );

  return { saveHistory, fetchHistoryList, fetchHistoryItem };
}
